// extracted by mini-css-extract-plugin
export default {"wrapper":"no-z","response":"oo-z","error":"po-z","disabled":"qo-z","buttons":"ro-z","feedbackQuestionSection":"so-z","yesNoWrapper":"to-z"};